// src/features/products/supplierApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const categoryApi = createApi({
  reducerPath: 'categoryApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.Category.get }),
  tagTypes: ['categoryApi'],
  endpoints: (builder) => ({
    getCategory: builder.query({
      query: () => "getCategories",
      keepUnusedDataFor: 35,
      providesTags: ['categoryApi'],
      invalidatesTags: ['categoryApi'],
    }),
    createCategory: builder.mutation({
      query: (supplier) => {
        const formData = new FormData();
        Object.entries(supplier).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.Category.post,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
       
        return response
      },
      invalidatesTags: ['categoryApi'], 
    }),
    updateCategory: builder.mutation({
      query: (CategoryData) => {
        const formData = new FormData();
        Object.entries(CategoryData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.Category.update + CategoryData.Id,
          method: 'PUT',
          body: formData,
          
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['categoryApi'],
    }),
    deleteCategory: builder.mutation({
      query: (id) => ({
        url: Urls.Category.delete + id,
        method: 'DELETE',
      }),
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['categoryApi'],
    }),
  }),
  keepUnusedDataFor: 1
});

export const {
  useGetCategoryQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;

